(() => {
  const second = 1000;
  const minute = 60 * second;
  const hour = 60 * minute;
  const day = 24 * hour;

  const render = (root) => {
    const end = Date.parse(root.dataset.endsAt || '');
    if (!Number.isFinite(end)) {
      root.hidden = true;
      return false;
    }
    const remaining = end - Date.now();
    if (remaining <= 0) {
      root.hidden = true;
      return false;
    }
    root.querySelector('[data-days]').textContent = Math.floor(remaining / day);
    root.querySelector('[data-hours]').textContent = String(Math.floor((remaining % day) / hour)).padStart(2, '0');
    root.querySelector('[data-minutes]').textContent = String(Math.floor((remaining % hour) / minute)).padStart(2, '0');
    root.querySelector('[data-seconds]').textContent = String(Math.floor((remaining % minute) / second)).padStart(2, '0');
    return true;
  };

  document.querySelectorAll('[data-sr-sale-countdown]').forEach((root) => {
    if (!render(root)) return;
    const interval = window.setInterval(() => {
      if (!render(root)) window.clearInterval(interval);
    }, second);
  });
})();
